import { Box, Text } from "@chakra-ui/react";
import { useEffect } from "react";
import { useRouter } from "next/router";
import Head from "next/head";

const RedirectPage = () => {
  const router = useRouter();

  useEffect(() => {
    router.replace("/whats-worrying-you");
  }, [router]);

  return (
    <Box w="100%" h="100vh">
      <Head>
        <title>Redirecting</title>
        <meta name="title" content="Redirecting" />
      </Head>
      <Box
        mx="auto"
        mt="40%"
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <Text as="h1" textStyle="h1" p="24px">
          Redirecting
        </Text>
      </Box>
    </Box>
  );
};

export default RedirectPage;
